export default "__VITE_ASSET__6df80f18__"